/* @flow */
import DialogContent from 'components/DialogContent.jsx';
import Modal from 'components/Modal.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/Dialog.scss';

/**
 * Standard modal dialogs
 *
 * Use [ModalTrigger](/components/ModalTrigger) to display the dialog.
 *
 * ```example
 *  <ModalTrigger
 *    modal={
 *      <Dialog
 *        title="Hello World!"
 *        subtext="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
 *        glyph="pencil"
 *        glyphColor="lava"
 *        size="xsmall">
 *        This is the content inside of the dialog.
 *      </Dialog>
 *    }>
 *    <Button>Show dialog</Button>
 *  </ModalTrigger>
 * ```
 */

class Dialog extends React.Component {
  static propTypes = {
    ...Modal.propTypes,
    ...DialogContent.propTypes,
  };

  static defaultProps = {
    hideCloseButton: false,
    hideOnBlur: true,
  };

  render() {
    const { className, ...props } = this.props;
    return (
      <Modal {...props} className={cx('Dialog', className)} title={null}>
        <DialogContent {...props} />
      </Modal>
    );
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog.jsx